import styled from "@emotion/styled";
import { Chip, Paper } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Tooltip from "@mui/material/Tooltip";

export const ProcessedTrucksCardWrapper = styled(Paper)(({ theme }) => ({
	width: "100%",
	margin: "0 auto",
	backgroundColor: theme.project.colors.backgroundColors.main,
	padding: "16px",
	display: "flex",
	flexDirection: "column",
	gap: "12px"
}));

export const StatusChip = styled(Chip)(({ theme }) => ({
	...theme.project.typography.chipLabel,
	display: "flex",
	height: "1.5rem",
	alignItems: "center",
	backgroundColor: theme.project.colors.backgroundColors.main,
	borderColor: theme.project.colors.primaryColors.main,
	textTransform: "capitalize",
	borderRadius: "100px",
	border: "1px solid",
	cursor: "pointer",
	color: theme.project.colors.primaryColors.main,
	"& .MuiChip-label": {
		paddingTop: 2.5
	}
}));

export const HeaderLeft = styled.div(({ theme }) => ({
	display: "flex",
	gridColumn: "span 6",
	gap: "24px",
	flex: 1,
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		gap: "16px"
	}
}));

export const TruckIdContainer = styled.div(({ theme }) => ({
	...theme.project.typography.heading.h6,
	color: theme.project.colors.fontColors.main,
	display: "flex",
	alignItems: "center",
	wordBreak: "break-all"
}));

export const StatusEtaContainer = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	gap: "8px",
	[theme.breakpoints.down("sm")]: {
		flexDirection: "column",
		alignItems: "flex-start"
	}
}));

export const Eta = styled.div(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle1,
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	gap: "8px",
	color: theme.project.colors.fontColors.secondary
}));

export const HeaderRight = styled.div({
	display: "flex",
	gridColumn: "span 2",
	width: "100%",
	justifyContent: "flex-start",
	alignItems: "center",
	flex: 1
});

export const TruckHeader = styled.div(({ theme }) => ({
	display: "grid",
	gridTemplateColumns: "repeat(8, 1fr)",
	gap: 16,
	[theme.breakpoints.down("md")]: {
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-start",
		gap: "16px",
		margin: "0"
	}
}));

export const TruckDetails = styled.div(({ theme, onClick }) => ({
	...(onClick && {
		cursor: "pointer",
		"&:hover": {
			backgroundColor: theme.project.colors.backgroundColors["card:hover"]
		}
	}),
	border: "1px solid #D0D0D0",
	display: "grid",
	gridTemplateColumns: "repeat(10, 1fr)",
	alignItems: "flex-start",
	gap: "24px",
	padding: "16px",
	[theme.breakpoints.down("md")]: {
		gridTemplateColumns: "1fr auto",
		gap: "8px",
		position: "relative"
	}
}));

export const DetailsListItem = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gridColumn: "span 1",
	[theme.breakpoints.down("md")]: {
		flexDirection: "row",
		gap: "8px",
		marginRight: "48px"
	}
}));

export const DetailsListItemTwoColumns = styled(DetailsListItem)(({ theme }) => ({
	gridColumn: "span 2"
}));

export const DetailsListItemStrong = styled.strong(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2,
	color: theme.project.colors.fontColors.main,
	whiteSpace: "nowrap"
}));

export const DetailsListItemParagraph = styled.p(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary,
	margin: 0
}));

export const ArrowContainer = styled.div(({ theme }) => ({
	gridColumn: "span 1",
	display: "flex",
	alignItems: "center",
	justifyContent: "flex-end",
	height: "100%",
	[theme.breakpoints.down("md")]: {
		gridColumn: "2 / 3",
		position: "absolute",
		right: 0
	}
}));

export const ArrowIcon = styled(ChevronRightIcon)(({ theme }) => ({
	cursor: "pointer",
	height: "24px",
	width: "24px",
	[theme.breakpoints.down("md")]: {
		alignSelf: "center"
	}
}));

export const CardTooltip = styled(({ className, ...props }: { className?: string; [key: string]: any }) => (
	<Tooltip
		{...props}
		classes={{ tooltip: className }}
		title={props.title || ""}
	>
		{props.children}
	</Tooltip>
))({
	maxWidth: "242px",
	whiteSpace: "normal"
});
